<template>
  <section class="home">
    <div class="home__slider" v-if="banners && banners.length">
      <div class="home-slider__arrows d-none d-xl-flex">
        <AppBtn :btnClass="'btn_grey'" @click.native="showPrev" class="_pa-3">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19 12H5M5 12L12 19M5 12L12 5"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </AppBtn>
        <AppBtn :btnClass="'btn_grey'" @click.native="showNext" class="_pa-3">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 12L19 12M19 12L12 5M19 12L12 19"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </AppBtn>
      </div>
      <VueSlickCarousel
        v-bind="settings"
        v-if="banners && banners.length"
        ref="otherSlider"
      >
        <!-- <TopBanner class="mb-16" :item="banners[0]">
          <template
            v-if="banners[0].buttonLink && banners[0].buttonText"
            slot="button"
          >
            <AppBtn
              @click.native="
                sliderButtonClick(banners[0].title, banners[0].buttonLink)
              "
              :btnClass="'btn_orange'"
              class="_mt-6"
            >
              <div class="_py-2 _px-3 _tc-white _fs-16">
                <span>{{ banners[0].buttonText }}</span>
              </div>
            </AppBtn>
          </template>
        </TopBanner> -->
        <TopBanner
          class="mb-16"
          v-for="(banner, i) in banners"
          :key="i"
          :item="banner"
        >
          <template v-if="banner.buttonLink && banner.buttonText" slot="button">
            <AppBtn
              @click.native="sliderButtonClick(banner.title, banner.buttonLink)"
              :btnClass="'btn_orange'"
              class="_mt-6"
            >
              <div class="_py-2 _px-3 _tc-white _fs-16">
                <span>{{ banner.buttonText }}</span>
              </div>
            </AppBtn>
          </template>
        </TopBanner>
      </VueSlickCarousel>
    </div>

    <div class="cards">
      <div class="container _pt-12 _px-md-4">
        <div class="cards-wrap">
          <VueSlickCarousel class="cards-container" v-bind="sectionsSlider">
            <MainPageSections
              v-for="(card, ind) in cards"
              :key="ind"
              :item="card"
            ></MainPageSections>
          </VueSlickCarousel>
        </div>
      </div>
    </div>

    <div class="bottom-banner__container" v-if="false">
      <div class="container _pt-12 _px-md-4">
        <div class="bottom-banner _pa-8">
          <picture>
            <source
              :srcset="require(`@/assets/img/blocks/leaderboard/block-375.jpg`)"
              media="(max-width: 767px)"
            />
            <source
              :srcset="require(`@/assets/img/blocks/leaderboard/block-768.jpg`)"
              media="(max-width: 1220px)"
            />
            <source
              :srcset="
                require(`@/assets/img/blocks/leaderboard/block-1920.jpg`)
              "
              media="(min-width: 1920px)"
            />
            <img
              class="bottom-banner__img"
              :src="require(`@/assets/img/blocks/leaderboard/block-1920.jpg`)"
            />
          </picture>
          <div class="bottom-banner__text-container">
            <h3
              class="bottom-banner__title _mb-2 _fw-600 _lh-38 _fs-32 _fs-sm-24 _lh-sm-32 _tc-dark"
            >
              Топ 10 лучших учеников
            </h3>
            <p
              class="bottom-banner__description _fs-20 _lh-26 _fs-sm-14 _lh-sm-20 _tc-dark"
            >
              Будьте активным пользователем и попадите в число лучших на доску
              достижений
            </p>
            <AppBtn :btnClass="'btn_orange'" class="_mt-4">
              <div
                @click="leaderBannerClick()"
                class="_tc-white _fs-18 _py-2 _px-3"
              >
                Лидерборд
              </div>
            </AppBtn>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-banner__container">
      <div class="container _py-12 _pb-md-12 _px-md-4">
        <div class="bottom-banner _pa-8">
          <picture>
            <source
              :srcset="
                require(`@/assets/img/blocks/intensives/locales/${currentLocale}/block-375.jpg`)
              "
              media="(max-width: 767px)"
            />
            <source
              :srcset="
                require(`@/assets/img/blocks/intensives/locales/${currentLocale}/block-768.jpg`)
              "
              media="(max-width: 1220px)"
            />
            <source
              :srcset="
                require(`@/assets/img/blocks/intensives/locales/${currentLocale}/block-1920.jpg`)
              "
              media="(min-width: 1920px)"
            />
            <img
              class="bottom-banner__img"
              :src="
                require(`@/assets/img/blocks/intensives/locales/${currentLocale}/block-1920.jpg`)
              "
            />
          </picture>
          <div class="bottom-banner__text-container">
            <h3
              class="bottom-banner__title _mb-2 _fw-600 _lh-38 _fs-32 _fs-sm-24 _lh-sm-32"
            >
              {{ $t("pages.home.bottom_block.title") }}
            </h3>
            <p
              class="bottom-banner__description _fs-20 _lh-26 _fs-sm-14 _lh-sm-20"
            >
              {{ $t("pages.home.bottom_block.description") }}
            </p>
            <AppBtn :btnClass="'btn_orange'" class="_mt-4">
              <div
                @click="bottomBannerClick()"
                class="_tc-white _fs-18 _py-2 _px-3"
              >
                {{ $t("pages.home.bottom_block.more") }}
              </div>
            </AppBtn>
          </div>
        </div>
      </div>
    </div>

    <div class="faq">
      <div class="container _pb-12 _pb-md-12 _px-md-4">
        <div class="faq-container">
          <div class="faq__left">
            <div
              class="_fs-20 _lh-24 _fw-700 _mb-6 _fs-sm-16 _lh-sm-20 _fw-sm-600"
            >
              {{ $t("pages.home.faq.title") }}
            </div>
            <div class="faq__left-list">
              <!-- <div
                @click="
                  modalToggle(
                    'faqPassword',
                    true,
                    $t('modals.faqPassword.title')
                  )
                "
                class="faq-link _fs-20 _lh-28 _fw-600 _mb-4"
              >
                {{ $t('pages.home.faq.items[0]') }}
              </div> -->
              <div
                @click="
                  modalToggle('faqSection', true, $t('modals.faqSection.title'))
                "
                class="faq-link _fs-20 _lh-28 _fw-600 _mb-4"
              >
                {{ $t("pages.home.faq.items[1]") }}
              </div>
              <!-- <div class="faq-link _fs-20 _lh-28 _fw-600">
                Мне не засчитали достижение
              </div> -->
            </div>
          </div>
          <div v-if="false" class="faq__right _pa-8 _mt-sm-8">
            <div
              class="_fs-20 _lh-24 _fw-700 _mb-2 _fs-sm-16 _lh-sm-20 _fw-sm-600"
            >
              {{ $t("pages.home.support.title") }}
            </div>
            <div class="_fs-16 _lh-24 _mb-9 _tc-dark-grey">
              {{ $t("pages.home.support.description") }}
            </div>
            <AppBtn
              @click.native="telegramClick()"
              class="_pa-0"
              :btnClass="'btn_blue'"
            >
              <span class="d-flex _px-5 _py-2">
                <img
                  :src="require('@/assets/img/icons/tg.svg')"
                  class="_mr-2"
                />
                <span class="_fs-16 _lh-24">Telegram</span>
              </span>
            </AppBtn>
          </div>
        </div>
      </div>
    </div>
    <div class="slider-block">
      <!-- <SocialsSlider :analyticEventPrefix="'mp'" /> -->
      <div class="facts-slider">
        <div class="container _pb-12 _pb-md-12 _px-md-4 _pt-12">
          <VueSlickCarousel v-bind="settingsOther" ref="centerSlider">
            <OtherBanner
              v-for="(other, index) in others"
              :key="index"
              :item="other"
            ></OtherBanner>
          </VueSlickCarousel>
        </div>
      </div>
    </div>
    <!-- <Modal v-if="faqPassword" @close="modalToggle('faqPassword', false)">
      <template v-slot:modalBody>
        <div class="_fs-24 _lh-24 _mb-4 _fw-700">
          {{ $t('modals.faqPassword.title') }}
        </div>
        <div class="_fs-18 _lh-20" v-html="$t('modals.faqPassword.body')"></div>
      </template>
    </Modal> -->
    <Modal v-if="faqSection" @close="modalToggle('faqSection', false)">
      <template v-slot:modalBody>
        <div class="_fs-24 _lh-24 _mb-4 _fw-700">
          {{ $t("modals.faqSection.title") }}
        </div>
        <div class="_fs-18 _lh-20" v-html="$t('modals.faqSection.body')"></div>
      </template>
    </Modal>
  </section>
</template>

<script>
import TopBanner from "@/components/UI/banners/TopBanner";
import OtherBanner from "@/components/UI/banners/OtherBanner";
import SocialsSlider from "@/components/UI/SocialsSlider.vue";
import AppBtn from "@/components/UI/buttons/AppBtn";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

import MainPageSections from "@/components/UI/MainPageSections";
import toPage from "@/mixins/toPage";
import { mapActions, mapGetters } from "vuex";
import Modal from "../components/UI/Modal.vue";
import { bus } from "@/main";

export default {
  name: "Home",
  components: {
    TopBanner,
    OtherBanner,
    SocialsSlider,
    AppBtn,
    MainPageSections,
    VueSlickCarousel,
    Modal,
  },
  mixins: [toPage],
  data: () => ({
    faqPassword: false,
    faqSection: false,
    settings: {
      slidesToShow: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
      draggable: false,
      responsive: [
        {
          breakpoint: 1220,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    },
    sectionsSlider: {
      slidesToShow: 1,
      infinite: false,
      autoplay: false,
      arrows: false,
      variableWidth: true,
      draggable: false,
      responsive: [
        {
          breakpoint: 9999999,
          settings: "unslick",
        },
        {
          breakpoint: 1220,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    },
    settingsOther: {
      slidesToShow: 1,
      infinite: true,
      autoplay: true,
      adaptiveHeight: true,
      autoplaySpeed: 10000,
      dots: false,
      arrows: false,
      fade: true,
    },
  }),
  computed: {
    ...mapGetters(["getBanners"]),
    currentLocale() {
      return this.Trans.currentLocale;
    },
    banners() {
      let arr = [];
      let images = [];
      this.getBanners
        .filter((el) => el.translates.length)
        .forEach(function (banner) {
          images = [];
          banner.banners.forEach(function (el) {
            images.push({
              src: el.image,
              media: el.media_str,
            });
          });
          arr.push({
            title: banner.translates[0].name,
            descr: banner.translates[0].description,
            pathIt: banner.translates[0].link,
            buttonText: banner.translates[0].button_text,
            buttonLink: banner.translates[0].button_link,
            theme: banner.theme,
            images: images,
          });
        });
      return arr;
    },
    cards() {
      const vm = this;
      return Array.isArray(this.$t("pages.home.cards"))
        ? this.$t("pages.home.cards")
            .filter((el) => el.id !== 5) // было 5 вместо 10. Заменить при необходимости скрыть элемент
            .map(function (el) {
              return {
                ...el,
                route: vm.helpers.buildRoute(el.route),
                images: el.images.map((img) => ({
                  ...img,
                  src: require(`@/assets/img/blocks/home/cards/${img.src}`),
                })),
              };
            })
        : null;
    },
    others() {
      let arr = [];
      const excludedSlides = [2, 3, 4, 10, 11, 19, 20]; // Общие исключения для всех языков
      
      // Для LT исключаем 18 (как у lv, et) + 12, 14, 17
      // Для остальных языков - только общие исключения
      const localeExcludedSlides = 
        this.currentLocale === 'lt' 
          ? [12, 14, 17]  // LT: исключаем 12, 14, 17 и 18
          : ['lv', 'et'].includes(this.currentLocale) 
              ? [18]  // LV, ET: только 18
              : [];  // Остальные языки: без дополнительных исключений

      for (let i = 1; i <= 21; i++) {
        // Пропускаем слайды из общего списка ИЛИ для текущего языка
        if (excludedSlides.includes(i) || localeExcludedSlides.includes(i)) continue;
        
        arr.push({
          title: "",
          theme: "",
          descr: "",
          images: [
            {
              src: require(`@/assets/img/blocks/home/slider/${this.Trans.currentLocale}/${i}/375.jpg`),
              media: "(max-width: 743px)",
            },
            {
              src: require(`@/assets/img/blocks/home/slider/${this.Trans.currentLocale}/${i}/744.jpg`),
              media: "(max-width: 1220px)",
            },
            {
              src: require(`@/assets/img/blocks/home/slider/${this.Trans.currentLocale}/${i}/1440.jpg`),
              media: "(min-width: 1440px)",
            },
          ],
        });
      }
      return arr;
    },
  },
  methods: {
    ...mapActions(["fetchBannersGroup", "fetchBanners", "SOCKET_SEND_MESSAGE"]),
    showNext() {
      this.$refs.otherSlider.next();
    },
    showPrev() {
      this.$refs.otherSlider.prev();
    },
    modalToggle(model, state, txt) {
      this[model] = state;
      bus.$emit("scrollLock", state);
      if (this.$gtm && txt) {
        this.$gtm.push({
          event: "mp_faq",
          param_value: this.helpers.stripHtml(txt),
        });
      }
    },
    sliderButtonClick(txt, path) {
      if (this.$gtm) {
        this.$gtm.push({
          event: "mp_slider_start_btn",
          param_value: this.helpers.stripHtml(txt),
        });
      }
      window.open(path, "_self");
    },
    telegramClick() {
      if (this.$gtm) {
        this.$gtm.push({
          event: "mp_telegram_support",
        });
      }
      window.open("https://t.me/+fR3ci9egP2tkZjc6", "_self");
    },
    bottomBannerClick() {
      if (this.$gtm) {
        this.$gtm.push({
          event: "mp_banner_more",
        });
      }
      this.$router.push(this.helpers.buildRoute({ name: "UsefulResources" }));
    },
    leaderBannerClick() {
      if (this.$gtm) {
        this.$gtm.push({
          event: "mp_banner_more",
        });
      }
      this.$router.push(this.helpers.buildRoute({ name: "Leaderboard" }));
    },
  },
  async mounted() {
    await this.fetchBannersGroup(this.currentLocale);
    this.SOCKET_SEND_MESSAGE(
      JSON.stringify({
        action: "set_path",
        path: this.$router.resolve({
          name: this.$route.name.replace("Loc", ""),
        }).href,
      })
    );
    // await this.fetchBanners(this.currentLocale)
  },
};
</script>

<style lang="scss">
.cards-container {
  width: 100%;
  &:not(.slick-slider) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    justify-items: center;
    grid-gap: 32px;
    @media screen and (max-width: 1220px) {
      grid-template-columns: 1fr;
    }
  }

  .other-materials {
    &__generate {
      width: 280px;
      height: 320px;
      // margin-bottom: 32px;
      @media screen and (max-width: 1220px) {
        // width: 100% !important;
      }
    }
    &__img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      object-fit: cover;
      object-position: top;
      z-index: 1;
    }
  }
}
.row-1-1 {
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 1220px) {
    grid-template-columns: 1fr;
  }
}

.gap-32 {
  grid-gap: 32px;
}

.home__slider {
  & .slick-list,
  & .slick-track {
    display: flex;
    align-items: stretch;
  }

  & .slick-slide {
    height: auto;

    & > * {
      height: 100%;
    }
  }
}
</style>

<style lang="scss" scoped>
.faq {
  &-container {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    @media screen and (max-width: 743px) {
      flex-flow: column;
      justify-content: center;
      align-items: flex-start;
    }
  }
  &__left {
    max-width: fit-content;
    &-list {
      display: flex;
      flex-direction: column;
    }
  }
  &-link {
    cursor: pointer;
    color: #69b3e7;
    text-decoration: underline;
  }
  &__right {
    max-width: 590px;
    width: 100%;
    border: 1px solid #d6dbe0;
    border-radius: 16px;
    @media screen and (max-width: 1023px) {
      max-width: 340px;
    }
    @media screen and (max-width: 743px) {
      max-width: 100%;
    }
  }
}
.home {
  &__slider {
    width: 100%;
    max-width: 1920px;
    position: relative;
    margin: 0 auto;
    @media screen and (max-width: 1919px) {
      max-width: 100vw;
    }
    & .top-banner {
      @media screen and (max-width: 1220px) {
        height: 100%;
      }
    }
  }

  &-slider {
    &__arrows {
      padding: 0 22px;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      z-index: 2;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }

    &__arrow {
      padding: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #707372;
      border-radius: 16px;
      flex-shrink: 0;
      cursor: pointer;
    }
  }
}
.bottom-banner {
  border-radius: 16px;
  overflow: hidden;
  position: relative;
  width: 100%;
  min-height: 196px;
  background-image: radial-gradient(
    74.59% 137.08% at 100% 58.47%,
    #96b2eb 0%,
    #4865a6 100%
  );

  @media screen and (max-width: 1220px) {
    height: auto;
  }

  @media screen and (max-width: 767px) {
    height: 456px;
  }

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  &__text-container {
    max-width: 55%;
    position: relative;
    z-index: 2;
    color: color(white);

    @media screen and (max-width: 1220px) {
      max-width: 45%;
    }

    @media screen and (max-width: 743px) {
      max-width: none;
    }
  }
}

.facts-slider {
  width: 100%;
  max-width: 100vw;

  & .slick-slider {
    width: auto;
  }
}

.slider-block {
  background-color: color(light);
}
</style>

<style lang="scss">
.cards-wrap {
  max-width: calc(100vw - 32px);

  & .slick-slide {
    padding: 0 16px;
  }
  & .slick-slider {
    margin: 0 -16px;
    // width: 100%;
    @media screen and (max-width: 1220px) {
      width: calc(100vw + 32px);
    }
  }
}
</style>
